// YunSection.js

import React from 'react'
import './YunSection.css';

const YunSection = (props) => {
    const sectionStyle = {
        width: props.width + 'px',
        height: props.height + 'px'
    };
    let classNameStr = props.active ? 'YunSection Active' : 'YunSection'
    if (props.className) {
        classNameStr = classNameStr + ' ' + props.className
    }
    return (
        <div style={sectionStyle} className={classNameStr}>
            {props.children}
        </div>
    )
}

export default YunSection;
